module.exports = __webpack_public_path__ + "img/wechat.24845993.jpg";